import {
  ADD_COMPONENT_TO_PAGE,
  CHANGE_PAGE_PROPERTY,
  CREATE_UNSAVED_PAGE,
  DELETE_PAGE_REJECTED,
  DELETE_PAGE_REQUESTED,
  DUPLICATE_PAGE,
  GET_PAGE_FAILURE,
  GET_PAGE_REQUEST,
  GET_PAGE_SUCCESS,
  PAGE_COMPONENTS_LIST_CHANGED,
  REMOVE_ACTIVE_PAGE,
  REMOVE_COMPONENT_FROM_PAGE,
  REPLACE_COMPONENT_ON_THE_PAGE,
  SAVE_PAGE_FAILURE,
  SAVE_PAGE_SUCCESS
} from './const';

/**
 * create a new unsaved page
 * @param {object} payload - page payload
 * @returns {object} action type and page payload
 */
export const createUnsavedPage = payload => ({
  type: CREATE_UNSAVED_PAGE,
  payload
});

/**
 * change a page property
 * @param {string} value - value for an edited page property
 * @param {string} field - corresponding value for page property
 * @returns {object} action type and pageName
 */
export const changePageProperty = (value, field) => ({
  type: CHANGE_PAGE_PROPERTY,
  value,
  field
});

/**
 * add component to component list
 * @param {object} component - component object
 * @returns {object} action type and component ID
 */
export const addComponentToPage = ({ component, position }) => ({
  type: ADD_COMPONENT_TO_PAGE,
  component,
  position
});

/**
 * action to replace a component on the page
 * @param {string} index - index of the component to be replaced
 * @param {object} component - component to be replaced with
 * @returns {object} action type and component ID
 */
export const replaceComponentOnPage = (index, component) => ({
  type: REPLACE_COMPONENT_ON_THE_PAGE,
  index,
  component
});

/**
 * remove last component from component list
 * @param {string} id - component id
 * @returns {object} action type
 */
export const removeComponentFromPage = id => ({
  type: REMOVE_COMPONENT_FROM_PAGE,
  id
});

/**
 * unset active page
 * @returns {object} action type
 */
export const removeActivePage = () => ({
  type: REMOVE_ACTIVE_PAGE
});

/**
 * get page request
 * @param {object} params - function params
 * @param {string} params.id - UUID of page
 * @param {string} params.version - page version
 * @returns {object} action type and request params
 */
export const getPageRequest = ({ id, version }) => ({
  type: GET_PAGE_REQUEST,
  id,
  version
});

/**
 * get page request success
 * @param {string} id - id from request
 * @param {object} page - return object from request success
 * @returns {object} action type and payload
 */
export const getPageSuccess = (id, page) => ({
  type: GET_PAGE_SUCCESS,
  id,
  page
});

/**
 * create action to duplicate the page
 * @param {object} pagePayload - return object from request success
 * @returns {object} action type and page payload
 */
export const duplicatePage = pagePayload => ({
  type: DUPLICATE_PAGE,
  pagePayload
});

/**
 * get page request failure
 * @param {object} error - error result
 * @returns {object} action type and error object
 */
export const getPageFailure = error => ({
  type: GET_PAGE_FAILURE,
  error
});

/**
 * Returns action for any change in the components array of the page.
 * @param {Array} ComponentList - Array of components on a page.
 * @returns {object} Action Object
 */
export const changePageComponentsList = ComponentList => ({
  type: PAGE_COMPONENTS_LIST_CHANGED,
  ComponentList
});

/**
 * save page request success
 * @param  {object} payload - return object from request success
 * @returns {object} action type and payload
 */
export const savePageSuccess = payload => ({
  type: SAVE_PAGE_SUCCESS,
  payload
});

/**
 * save page request failed
 * @param  {object} payload - return object from request success
 * @param {object} error - failure error object from schedule to publish.
 * @returns {object} action type and payload
 */
export const savePageFailure = (payload, error) => ({
  type: SAVE_PAGE_FAILURE,
  payload,
  error
});

/**
 * trigger a request to delete page
 * @returns {object} an action object
 */
export const deletePageRequest = () => ({
  type: DELETE_PAGE_REQUESTED
});

/**
 * handle delete page request success
 * @param {Error} error - the error object describing the failure
 * @returns {object} an action object
 */
export const deletePageFailure = error => ({
  type: DELETE_PAGE_REJECTED,
  error
});
